import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('fraud_detection_changes_made_after_approval'),
    subtitle: defineMessage('which_changes_made_in_x_isations_administrators'),
    contactIdLabel: defineMessage('contact'),
    netAmountLabel: defineMessage('net_total_amount_more_t_panycurrencycode_change'),
    trackingCategoriesLabel: defineMessage('tracking_category_4'),
    lineItemAccountCodeLabel: defineMessage('account'),
    lineItemCodeLabel: defineMessage('item'),
    lineItemDescriptionLabel: defineMessage('description_more_than_difference'),
    currencyLabel: defineMessage('currency'),
};
